import Download from '../../spa/download/Download';

export default {
  path: 'download',
  name: 'download',
  component: Download,
};
